import {
  Text,
  GreyGrey10,
  GreyGrey30,
  GreyGrey60,
  Primary13SemiBold,
  Center,
  Box
} from '@sequencehq/core-components'

interface EmptyStateProps {
  label: string
  Icon: JSX.Element
}

export const EmptyState = ({ Icon, label }: EmptyStateProps) => {
  return (
    <Box
      borderRadius="6px"
      width="100%"
      height="80%"
      justifyContent="center"
      alignItems="center"
      display="flex"
      flexDirection="column"
      backgroundColor={GreyGrey10}
      gap="12px"
    >
      <Center
        borderRadius="6px"
        width="24px"
        height="24px"
        backgroundColor={GreyGrey30}
      >
        {Icon}
      </Center>
      <Text {...Primary13SemiBold} color={GreyGrey60}>
        {label}
      </Text>
    </Box>
  )
}
